<template>
  <div class="mainContainer">
    <div class="nav">
      <div class="navContainer" style="width: 240px">
        <p>对账单编号：</p>
        <el-input v-model="searchForm.settNo" size="mini" style="width: 150px" placeholder="请输入对账单编号" />
      </div>
      <div class="navContainer" style="width: 240px">
        <p style="width: 50px">标题：</p>
        <el-input v-model="searchForm.title" size="mini" style="width: 150px" placeholder="请输入标题" />
      </div>

      <div class="navContainer" style="width: 240px">
        <p style="width: 60px; margin-left: -35px">委托商：</p>
        <el-input v-model="searchForm.companyName" size="mini" style="width: 150px" placeholder="请输入委托商" />
      </div>
      <div class="navContainer" style="width: 420px">
        <p style="width: 120px; margin-left: -65px">对账单生成时间：</p>
        <el-date-picker v-model="searchForm.startTime" size="mini" style="width: 150px" value-format="yyyy-MM-dd" @change="dateChange" type="date" placeholder="开始日期" />
        <span style="display: inline-block; width: 15px; text-align: center; font-size: 18px">-</span>
        <el-date-picker v-model="searchForm.endTime" size="mini" style="width: 150px" value-format="yyyy-MM-dd" @change="dateChange" type="date" placeholder="结束日期" />
      </div>
      <div class="navContainer" style="width: 240px">
        <p style="width: 50px">状态：</p>
        <el-select v-model="searchForm.status" filterable size="mini" style="width: 150px" placeholder="请选择状态">
          <el-option v-for="item in stateOption" :key="item.label" :label="item.label" :value="item.value" />
        </el-select>
      </div>
      <div class="navContainer" style="width: 240px">
        <p>结算方式：</p>
        <el-select v-model="searchForm.settType" filterable size="mini" style="width: 150px" placeholder="请选择结算方式">
          <el-option v-for="item in typeOption" :key="item.label" :label="item.label" :value="item.value" />
        </el-select>
      </div>
      <div class="navContainer" style="width: 240px">
        <p style="width: 70px">对账人员：</p>
        <el-input v-model="searchForm.reconciliator" size="mini" style="width: 170px" placeholder="请输入对账人员" />
      </div>
      <div class="navBtn">
        <el-button size="small" class="searchBtn" @click="searchBtn">查询</el-button>
        <el-button size="small" class="resetBtn" @click="resetBtn">重置</el-button>
      </div>
    </div>
    <el-row>
      <el-col :span="24" style="text-align: end; font-size: 14px !important" class="exportButton">
        <span style="color: red;">{{ msg }}</span>
        <span @click="exportData">详情批量导出</span>
        <span @click="exportDatas">导出数据</span>
      </el-col>
    </el-row>
    <div class="content">
      <div class="tableContainer">
        <el-table
          v-loading="tableLoad"
          :data="TableDatas"
          style="width: 100%"
          max-height="600px"
          ref="listTable"
          border
          :header-cell-style="{ color: '#3B3B3B', 'font-size': '13px', height: '48px', background: '#E8E8E8' }"
          :cell-style="{ color: '#7F7F7F', 'font-size': '13px', height: '52px' }"
          :expand-row-keys="expands"
          :row-key="
            row => {
              return row.id;
            }
          "
          @selection-change="selectionDataChange"
          :row-style="rowStyle">
          <el-table-column type="selection" align="center" width="50px" />
          <el-table-column label="序号" align="center" width="50px" type="index" />
          <el-table-column prop="settNo" label="对账单编号" align="center" />
          <el-table-column prop="title" label="标题" align="center" />
          <el-table-column label="结算方式" prop="settType" align="center" width="150" :formatter="settTypeFormat" />
          <el-table-column label="委托商" align="center" show-overflow-tooltip width="150">
            <div slot-scope="scope" style="display: flex; align-items: center; justify-content: center">
              {{ scope.row.companyNameNew }}
              <!-- 判断委托商是否 与原委托商相同  不同则展示         -->
              <el-tooltip v-if="scope.row.companyNameNew !== scope.row.companyNameOld" :content="`原结算单位：${scope.row.companyNameOld}`" placement="bottom" effect="light">
                <img v-if="scope.row.companyNameOld" alt="" :src="require('@/assets/images/warnning.png')" />
              </el-tooltip>
            </div>
          </el-table-column>
          <el-table-column prop="counts" label="数量" align="center" width="90px" />
          <el-table-column prop="settINum" label="结算数量" width="140" align="center" show-overflow-tooltip />
          <el-table-column prop="settlementPrice" label="结算金额（含税）" align="center" width="120px" />
          <el-table-column prop="otherPrice" label="其他费用金额（含税）" align="center" width="150px" />
          <el-table-column prop="taxPrice" label="合计金额（含税）" align="center" width="120px">
            <template slot-scope="scope" style="display: flex; align-items: center; justify-content: center">
              <span>{{ scope.row.settType === 1 ? scope.row.taxPrice : scope.row.taxSettPrice }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="taxRate" label="税率（%）" align="center" width="90px">
            <template slot-scope="scope" style="display: flex; align-items: center; justify-content: center">
              <span>{{ scope.row.taxRate }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="deductAmount" label="抵扣费用" align="center" width="150" show-overflow-tooltip />
          <!-- <el-table-column label="发票号" align="center" width="150" show-overflow-tooltip>
            <template slot-scope="scope" style="display: flex; align-items: center; justify-content: center">
              <span>
                {{ getInvoiceNo(scope.row) }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="发票时间" align="center" width="150" show-overflow-tooltip>
            <template slot-scope="scope" style="display: flex; align-items: center; justify-content: center">
              <span>
                {{ getInvoiceCreateTime(scope.row) }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="发票金额" align="center" width="150" show-overflow-tooltip>
            <template slot-scope="scope" style="display: flex; align-items: center; justify-content: center">
              <span>
                {{ getInvoicePrice(scope.row) }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="发票税率" prop="invoiceTaxRate" align="center" width="150" show-overflow-tooltip></el-table-column> -->
          <el-table-column label="发票号" prop="invoiceNo" align="center" width="150" show-overflow-tooltip></el-table-column>
          <el-table-column label="发票时间" prop="invoiceDate" align="center" width="150" show-overflow-tooltip></el-table-column>
          <el-table-column label="发票金额" prop="invoicePrice" align="center" width="150" show-overflow-tooltip></el-table-column>
          <el-table-column label="发票税率" prop="invoiceTaxRate" align="center" width="150" show-overflow-tooltip></el-table-column>
          <el-table-column label="发票代码" prop="invoiceCode" align="center" width="150" show-overflow-tooltip></el-table-column>
          <el-table-column prop="createTime" label="对账单生成时间" min-width="120" align="center" />
          <el-table-column prop="endDate" label="已开票" align="center">
            <template slot-scope="scope" style="display: flex; align-items: center; justify-content: center">
              <span>
                {{ scope.row.isBillingType === 0 ? '暂未开票' : scope.row.isBillingType === 1 ? '已开票' : '暂未开票' }}
              </span>
            </template>
          </el-table-column>
          <el-table-column prop="status" label="状态" align="center">
            <div slot-scope="scope">{{ getState(scope.row.status) }}</div>
          </el-table-column>
          <el-table-column label="推送状态" width="140" align="center" show-overflow-tooltip>
            <template slot-scope="scope" style="display: flex; align-items: center; justify-content: center">
              <span>{{ scope.row.isSend==1?'已推送':'未推送' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="reconciliator" label="对账人员" width="140" align="center" show-overflow-tooltip />
          <el-table-column prop="remark" label="备注" width="140" align="center" show-overflow-tooltip />

          <!--          <el-table-column prop='operateRecord.operationName' label='操作人' width='140' align='center' show-overflow-tooltip />-->
          <el-table-column label="操作" width="460" align="center" fixed="right">
            <template slot-scope="scope">
              <div>
                <el-button v-if="scope.row.isHongchong != 1 && scope.row.status === 0 || scope.row.status === -1" size="mini" class="searchBtn btnTopBottom10" type="primary" @click="changeClick(scope.row.id)">核对对账单 </el-button>
                <el-button v-if="scope.row.isHongchong != 1" size="mini" class="searchBtn btnTopBottom10" type="primary" @click="detailClick(scope.row.id, scope.row.settNo)">详情 </el-button>
                <el-button v-if="scope.row.isHongchong != 1 && scope.row.status === 0 || scope.row.status === -1" size="mini" type="primary" @click="auditClick(scope.row.id, scope.row.reconciliator)" class="btnTopBottom10">提交审核 </el-button>
                <el-button v-if="scope.row.isHongchong != 1 && scope.row.status === 1" size="mini" type="danger" @click="disableClick(scope.row.id, scope.row.reconciliator)" class="btnTopBottom10">取消审核 </el-button>
                <el-button v-if="scope.row.isHongchong != 1 && scope.row.status === 3" size="mini" type="primary" @click="invoiceClick(scope.row.id)" class="btnTopBottom10">寄送发票 </el-button>
                <!--                v-if="scope.row.status===3"-->
                <el-button v-if="scope.row.isHongchong != 1 && scope.row.status === 0" size="mini" type="primary" @click="titleChange(scope.row.id, scope.row.reconciliator)" class="btnTopBottom10">更改标题 </el-button>
                <el-button v-if="scope.row.isHongchong != 1 && scope.row.status === 0 || scope.row.status === -1" size="mini" type="info" @click="deleteClick(scope.row.id, scope.row.reconciliator)" class="btnTopBottom10">删除 </el-button>
                <el-button v-if="scope.row.isHongchong != 1" size="mini" type="primary" @click="editRemark(scope.row)" class="btnTopBottom10">修改备注</el-button>
                <el-button v-if="scope.row.isHongchong != 1" size="mini" type="danger" @click="hongChong(scope.row)" class="btnTopBottom10">红冲</el-button>
                <!--                <el-button v-if='scope.row.status === 2' size='mini' type='primary'
                                           :loading='invoicingLoading' @click='submitBillingClick(scope.row.id)'>
                                  提交开票
                                </el-button>-->
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paginationContainer">
        <span>共{{ total }}条</span>
        <el-pagination background :page-sizes="[10, 20, 30]" layout="sizes,prev, pager, next,jumper" :total="total" @size-change="contractSizeChange" @current-change="contractCurrentChange" @prev-click="contractCurrentChange" @next-click="contractCurrentChange" />
      </div>
    </div>
    <el-dialog title="详情" :visible.sync="detailDialogVisible" :width="detailDialogWidth" @close="detailClose" center top="10vh">
      <portChargesDetail
        ref="portChargesDetail"
        :detail="detailData"
        @tab-click-width="
          tabName => {
            this.activeName = tabName;
          }
        ">
      </portChargesDetail>
    </el-dialog>
    <!-- 核对对账单 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="1200px" center @close="dialogClose" :close-on-click-modal="false">
      <div class="detail">
        <div class="baseInfo">
          <div class="baseInfoTitle">
            <div class="line" />
            <span>基础信息</span>
          </div>
          <div class="baseInfoContent">
            <div class="baseInfoContentItem">
              <span class="span1">委托商：</span>
              <span>{{ companyData.companyNameNew }}</span>
            </div>
            <div class="baseInfoContentItem">
              <span class="span1">标题：</span>
              <span>{{ companyData.title }}</span>
            </div>
            <div class="baseInfoContentItem specialItem">
              <div class="specialOne">
                <span class="span1">合计含税费用：</span>
                <span>{{ companyData.settType === 1 ? companyData.taxPrice : companyData.taxSettPrice || 0 }}元</span>
              </div>
              <div>
                <span class="span1">合计不含税费用：</span>
                <span>{{ companyData.settType === 1 ? companyData.noTaxPrice : companyData.noTaxSettPrice || 0 }}元</span>
              </div>
            </div>
            <el-tabs v-model="activeName1">
              <el-tab-pane label="作业费用核对" name="first">
                <!--                <div class="baseInfoContentItem">-->
                <!--                  <span class="span1">结算方式：</span>-->
                <!--                  <span>{{companyData.name}}</span>-->
                <!--                </div>-->
                <div class="baseInfoContentItem specialItem">
                  <div class="specialOne">
                    <span class="span1">合计含税结算金额：</span>
                    <span>{{ companyData.settlementPrice }}元</span>
                  </div>
                  <div>
                    <span class="span1">合计不含税结算金额：</span>
                    <span>{{ settlementPriceCalculation }}元</span>
                  </div>
                </div>
                <div class="baseInfoContentItem" style="display: flex">
                  <span class="span1">上传时间：</span>
                  <span>{{ companyData.time }}</span>
                  <span class="spanStyle" @click="download">下载</span>
                  <span class="spanStyle">
                    <el-upload ref="upload" class="upload-demo" :disabled="uploadDis" :action="uploadUrl" :auto-upload="true" :show-file-list="false" :data="uploadData" :http-request="uploadHttp" :on-success="planOnSuccess" :before-upload="beforeUpload">重新上传 </el-upload>
                  </span>
                </div>
              </el-tab-pane>
              <el-tab-pane label="其它费用核对" name="second">
                <div class="baseInfoContentItem specialItem">
                  <div class="specialOne">
                    <span class="span1">其它费合计含税费用：</span>
                    <span>{{ companyData.otherPrice || 0 }}元</span>
                  </div>
                  <div>
                    <span class="span1">其它费合计不含税费用：</span>
                    <span> {{ Number(sumCost(tableData2, 'excludingTaxAmount')).toFixed(2) }}元 </span>
                  </div>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
          <div class="operation">
            <div class="operationTitle">
              <div class="line" />
              <span>{{ activeName1 === 'first' ? '异常数据' : '已选择其它费用' }}</span>
            </div>
            <div class="operationTable" v-if="activeName1 === 'first'">
              <el-table :data="tableData1" v-loading="tableLoad1" :row-class-name="tableRowClassName" border script>
                <el-table-column label="序号" align="center" type="index" />
                <el-table-column label="作业类型" min-width="120" align="center" show-overflow-tooltip>
                  <template slot-scope="scope">
                    {{ scope.row.transportationTerms === 1 ? '装船' : '卸船' }}
                  </template>
                </el-table-column>
                <el-table-column prop="waybillNo" label="运单编号" align="center" show-overflow-tooltip />
                <el-table-column prop="frameNumber" label="车架号" align="center" show-overflow-tooltip />
                <el-table-column prop="taxRate" label="税率(%)" align="center" />
                <el-table-column prop="taxPrice" label="含税单价" align="center" />
                <el-table-column prop="neTaxPrice" label="不含税单价" align="center">
                  <template slot-scope="scope">
                    {{ ((scope.row.taxPrice * (100 - scope.row.taxRate)) / 100).toFixed(2) }}
                  </template>
                </el-table-column>
                <el-table-column prop="type" label="异常类型" align="center">
                  <template slot-scope="scope">
                    {{ scope.row.type === 1 ? '数据未找到' : scope.row.type === 2 ? '未导入数据' : '价格异常' }}
                  </template>
                </el-table-column>
                <el-table-column prop="remark" label="说明" align="center" show-overflow-tooltip />
                <el-table-column label="操作" align="center" width="170">
                  <template slot-scope="scope">
                    <div v-if="scope.row.type !== 1" style="display: flex; align-items: center; justify-content: center; padding: 5px">
                      <el-button size="mini" type="primary" @click="changePriceClick(scope.$index, scope.row)">修改金额 </el-button>
                      <el-button size="mini" type="danger" @click="removeClick(scope.$index, scope.row, 0)"> 删除 </el-button>
                    </div>
                    <div v-else>--</div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="operationTable" v-else>
              <div class="operationTableNav">
                <span @click="exportClick">添加</span>
              </div>
              <el-table :data="tableData2" v-loading="tableData2Loading" :row-class-name="tableRowClassName" border script>
                <el-table-column label="序号" align="center" type="index" />
                <el-table-column prop="costNum" label="费用编号" align="center" />
                <el-table-column prop="costTypeName" label="费用类型" align="center" />
                <el-table-column prop="costInstruction" label="费用说明" align="center" />
                <el-table-column prop="costTime" label="费用时间" align="center">
                  <template slot-scope="scope">{{ scope.row.costTime | formatTime }}</template>
                </el-table-column>
                <el-table-column prop="taxRate" label="税率(%)" align="center" />
                <el-table-column prop="costAmount" label="含税价" align="center" />
                <el-table-column prop="excludingTaxAmount" label="不含税价" align="center" />
                <el-table-column prop="remark" label="说明" align="center" />
                <el-table-column label="操作" align="center" width="50px">
                  <div slot-scope="scope" style="display: flex; align-items: center; justify-content: center" v-if="tableData2.length > 0">
                    <img alt="" :src="require('@/assets/images/u725.png')" :style="'width:22px;height:22px;cursor: pointer;'" @click="removeClick(scope.$index, scope.row, 1)" />
                  </div>
                </el-table-column>
              </el-table>
            </div>
          </div>
          <!--          <div class='operation'>
                      <div class='operationTitle'>
                        <div class='line' />
                        <span>{{ activeName === 'first' ? '未选择运单' : '未选择其它费用' }}</span>
                      </div>
                      <div class='operationTable' v-if="activeName==='first'">
                        <el-table
                          :data='tableData3'
                          :row-class-name='tableRowClassName'
                          border
                          script
                        >
                          <el-table-column label='序号' align='center' type='index' />
                          <el-table-column prop='workNumber' label='作业编号' align='center' />
                          <el-table-column prop='portName' label='作业港口' align='center' />
                          <el-table-column prop='workType' label='作业类型' align='center'>
                            <template slot-scope='scope'>{{ scope.row.workType |workTypeFormat }}</template>
                          </el-table-column>
                          <el-table-column prop='batchNumber' label='批次号' align='center' />
                          <el-table-column prop='chassisNumber' label='底盘号' align='center' />
                          <el-table-column prop='brandName' label='品牌' align='center' />
                          <el-table-column prop='modelName' label='型号' align='center' />
                          <el-table-column prop='taxRate' label='税率(%)' align='center' />
                          <el-table-column prop='taxPrice' label='含税单价' align='center' />
                          <el-table-column prop='price' label='不含税单价' align='center' />
                          <el-table-column prop='remark' label='说明' align='center' />
                          <el-table-column label='操作' align='center' width='170'>
                            <template slot-scope='scope'>
                              <div style='display:flex;align-items:center;padding-left: 10px'>
                                <el-button size='mini' type='primary' @click='addTableClick(scope.$index, 0)'>
                                  添加
                                </el-button>
                                <el-button size='mini' type='primary'>首页提醒</el-button>
                              </div>
                            </template>
                          </el-table-column>
                        </el-table>
                      </div>
                      <div class='operationTable' v-if="activeName!=='first'">
                        <el-table
                          :data='tableData4'
                          :row-class-name='tableRowClassName'
                          border
                          script
                        >
                          <el-table-column label='序号' align='center' type='index' />
                          <el-table-column prop='costNum' label='费用编号' align='center' />
                          <el-table-column prop='costTypeName' label='费用类型' align='center' />
                          <el-table-column prop='costInstruction' label='费用说明' align='center' />
                          <el-table-column prop='costTime' label='费用时间' align='center'>
                            <template slot-scope='scope'>{{ scope.row.costTime |formatTime }}</template>
                          </el-table-column>
                          <el-table-column prop='taxRate' label='税率(%)' align='center' />
                          <el-table-column prop='costAmount' label='含税价' align='center' />
                          <el-table-column prop='excludingTaxAmount' label='不含税价' align='center' />
                          <el-table-column prop='remark' label='说明' align='center' />
                          <el-table-column label='操作' align='center' width='75'>

                            <div style='display:flex;align-items:center;padding-left: 10px'
                                 slot-scope='scope'>
                              <el-button size='mini' type='primary' @click='addTableClick(scope.$index, 1)'>
                                添加
                              </el-button>
                            </div>


                          </el-table-column>
                        </el-table>
                      </div>
                    </div>-->
        </div>
      </div>
    </el-dialog>
    <el-dialog title="选择适配车型" :visible.sync="carVisible" width="600px" @close="carClose" center :close-on-click-modal="false" top="20vh">
      <div class="carContainer">
        <div class="carContainerTitle">
          <span>已选择车型：</span>
          <div class="carContainerTitleContent">
            <div class="carContainerTitleContentItem" v-for="item in selectCar" @click="selectRemove(item)">{{ item.name }}<i class="el-icon-close" /></div>
          </div>
        </div>
        <div class="carContainerTitle">
          <span>选择品牌：</span>
          <div class="carContainerTitleContent">
            <div class="carContainerTitleContentItem" v-for="item in selectBrand">
              <p @click="brandClick(item.id)">{{ item.name }}&nbsp;</p>
              <i class="el-icon-plus" @click="brandAdd(item)" />
            </div>
          </div>
        </div>
        <div class="carContainerTitle">
          <span>选择型号：</span>
          <div class="carContainerTitleContent">
            <div class="carContainerTitleContentItem" v-for="item in selectModel" @click="modelAdd(item)">
              <p>{{ item.name }}</p>
              <i class="el-icon-plus" />
            </div>
          </div>
        </div>
        <div class="btnContainer">
          <el-button class="searchBtn" size="mini" @click="carAddClick">确定</el-button>
          <el-button class="resetBtn" size="mini" @click="carClose">关闭</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="添加其它费用" :visible.sync="addVisible" width="1000px" @close="addClose" center :close-on-click-modal="false" top="20vh">
      <!-- otherDataCelect  多选表格触发联动  otherDateProps 传递已有数据用以回显   consignor-id 供应商，公司id 分页查询用 -->
      <accounts-other-add ref="otherAdds" @closeDialog="addClose" @addOther="getPageListSOCI" :account-id="basicId" :consignor-id="companyData.companyId" />
    </el-dialog>
    <el-dialog title="填写发票寄送方式" :visible.sync="invoiceVisible" width="600px" @close="invoiceClose" center :close-on-click-modal="false">
      <invoice ref="invoice">
        <template slot-scope="scope" slot="determine">
          <el-button size="medium" class="searchBtn" :loading="addLoad" @click="addClick(scope.invoiceData)">确定 </el-button>
        </template>
        <template slot="close">
          <el-button size="medium" class="resetBtn" @click="invoiceClose">关闭</el-button>
        </template>
      </invoice>
    </el-dialog>
    <!-- 提交审核 -->
    <el-dialog title="提交审核" :visible.sync="auditVisible" width="1050px" @close="auditClose" center :close-on-click-modal="false">
      <div class="depart">
        <el-form :model="auditData" label-width="120px" :rules="rules2" ref="ruleForm2" size="medium">
          <div-border label="开票选择" divStyle="margin-top: 10px;padding-top:15px;">
            <el-row>
              <el-col :span="12">
                <el-form-item label="购买方名称：" label-width="150px" style="margin-bottom: 0">
                  {{ auditData.purchaserName }}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="销售方名称：" label-width="150px" style="margin-bottom: 0">
                  {{ auditData.sellerName }}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="购买纳税人识别号：" label-width="150px" style="margin-bottom: 0">
                  {{ auditData.purchaserDentificaNumber }}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="销售纳税人识别号：" label-width="150px" style="margin-bottom: 0">
                  {{ auditData.sellerDentificaNumber }}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="购买方地址：" label-width="150px" style="margin-bottom: 0">
                  {{ auditData.purchaserAddress }}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="销售方地址：" label-width="150px" style="margin-bottom: 0">
                  {{ auditData.sellerAddress }}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="购买方电话：" label-width="150px" style="margin-bottom: 0">
                  {{ auditData.purchaserTel }}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="销售方电话：" label-width="150px" style="margin-bottom: 0">
                  {{ auditData.sellerTel }}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="购买方开户行：" label-width="150px" style="margin-bottom: 0">
                  {{ auditData.purchaserBankDeposit }}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="销售方开户行：" label-width="150px" style="margin-bottom: 0">
                  {{ auditData.sellerBankDeposit }}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="购买方银行账号：" label-width="150px" style="margin-bottom: 0">
                  {{ auditData.purchaserBankAccount }}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="销售方银行账号：" label-width="150px" style="margin-bottom: 0">
                  {{ auditData.sellerBankAccount }}
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="是否开具销售清单：" label-width="150px" style="margin-bottom: 0" prop="type">
                  <el-radio v-model="isSalesList" :label="0">否</el-radio>
                  <el-radio v-model="isSalesList" :label="1">是</el-radio>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="交付方式：" label-width="150px" style="margin-bottom: 0">
                  <el-select v-model="auditDataSelectedValue.pushType" filterable size="mini" style="width: 188px" placeholder="请选择状态">
                    <el-option label="不交付" :value="-1" />
                    <el-option label="邮箱交付" :value="0" />
                    <el-option label="手机交付" :value="1" />
                    <el-option label="邮箱、手机交付" :value="2" />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="发票种类：" label-width="150px" style="margin-bottom: 0">
                  <el-select v-model="auditDataSelectedValue.invoiceLine" filterable size="mini" style="width: 188px" placeholder="请选择状态">
                    <el-option label="增值税专用发票" :value="0" />
                    <el-option label="增值税普通发票(纸票)" :value="2" />
                    <el-option label="机动车销售统一发票" :value="12" />
                    <el-option label="增值税普通发票(卷式)" :value="41" />
                    <el-option label="二手车销售统一发票" :value="42" />
                    <el-option label="增值税普通电子发票" :value="51" />
                    <el-option label="增值税专用电子发票" :value="52" />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="开票类型：" label-width="150px" style="margin-bottom: 0">
                  <el-select v-model="auditDataSelectedValue.invoiceBlueOrRed" filterable size="mini" style="width: 188px" placeholder="请选择状态">
                    <el-option label="蓝字发票" :value="0" />
                    <el-option label="红字发票" :value="1" />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12" v-if="auditDataSelectedValue.invoiceBlueOrRed === 1">
                <el-form-item label="开具红票理由：" label-width="150px" style="margin-bottom: 0">
                  <el-select v-model="auditDataSelectedValue.blueRedReason" filterable size="mini" style="width: 188px" placeholder="请选择状态">
                    <el-option label="销货退回" :value="1" />
                    <el-option label="开票有误" :value="2" />
                    <el-option label="服务中止" :value="3" />
                    <el-option label="销售折让" :value="4" />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="发票标识：" label-width="150px" style="margin-bottom: 0">
                  <el-select v-model="auditDataSelectedValue.invoiceFlag" filterable size="mini" style="width: 188px" placeholder="请选择状态">
                    <el-option label="普通发票" :value="0" />
                    <el-option label="成品油发票" :value="1" />
                    <el-option label="收购发票" :value="2" />
                    <el-option label="机动车发票" :value="3" />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="代开标志：" label-width="150px" style="margin-bottom: 0">
                  <el-select v-model="auditDataSelectedValue.proxyInvoiceFlag" filterable size="mini" style="width: 188px" placeholder="请选择状态">
                    <el-option label="非代开" :value="0" />
                    <el-option label="代开" :value="1" />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="纳税原因说明：" label-width="150px" style="margin-bottom: 0">
                  <el-select v-model="auditDataSelectedValue.specialTaxRateReason" filterable size="mini" style="width: 188px" placeholder="请选择状态">
                    <el-option label="无理由" :value="0" />
                    <el-option label="政策出台前发生纳税义务" :value="1" />
                    <el-option label="前期已开具相应征收率发票，发生销售折让、中止或者退回等情形需要开具红字发票，或者开票有误需要重新开具" :value="2" />
                    <el-option label="因为实际经营业务需要，放弃享受免征增值税政策" :value="3" />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="发票备注：" label-width="150px" style="margin-bottom: 0">
                  <el-input type="textarea" v-model="auditDataSelectedValue.invoiceRemark" :rows="3" placeholder="请输入发票备注" style="width: 83%" />
                </el-form-item>
              </el-col>
            </el-row>

            <div>
              <el-row type="flex" justify="space-between" align="middle" style="margin-bottom: 10px">
                <el-col :span="12">
                  <el-button type="primary" @click="addInvoice">添加</el-button>
                </el-col>
                <el-col :span="12">
                  <div style="float: right">结算数量：{{ auditData.settlementNum || 0 }} 剩余未结算数量：{{ settlementQuantityCalculation || 0 }} 其他数量：{{ auditData.otherNum || 0 }} 剩余其他未结算数量：{{ otherNumCalculation || 0 }}</div>
                </el-col>
              </el-row>
              <div class="tableContainer">
                <el-table :data="invoiceTableData" style="width: 100%; margin-bottom: 10px" border stripe :header-cell-style="headerCellStyle" :cell-style="cellStyle">
                  <el-table-column label="序号" align="center" type="index" />
                  <el-table-column width="160px" label="服务名称" prop="serviceName" align="center" show-overflow-tooltip />
                  <el-table-column width="200px" label="规格型号" prop="specificaModel" align="center" show-overflow-tooltip />
                  <el-table-column label="结算数量" prop="settlementNum" align="center" show-overflow-tooltip />
                  <el-table-column width="120p" x label="其它结算数量" prop="otherNum" align="center" show-overflow-tooltip />
                  <el-table-column width="150px" label="不含税金额" prop="price" align="center" show-overflow-tooltip />
                  <el-table-column label="税率(%)" prop="taxRate" align="center" show-overflow-tooltip />
                  <el-table-column label="含税金额" prop="taxPrice" align="center" show-overflow-tooltip />
                  <el-table-column width="200px" label="是否抵扣开票" align="center" show-overflow-tooltip>
                    <template slot-scope="scope">
                      {{ scope.row.isDeduct ? '是' : '否' }}
                    </template>
                  </el-table-column>
                  <el-table-column width="200px" label="是否抵扣超出合同价对账单" align="center" show-overflow-tooltip>
                    <template slot-scope="scope">
                      {{ scope.row.isDeductionPrice ? '是' : '否' }}
                    </template>
                  </el-table-column>
                  <el-table-column width="200px" label="是否暂缓开票" prop="se" align="center" show-overflow-tooltip>
                    <template slot-scope="scope">
                      {{ scope.row.isSuspendBilling ? '是' : '否' }}
                    </template>
                  </el-table-column>
                  <el-table-column width="200px" label="操作" align="center" fixed="right">
                    <template slot-scope="scope">
                      <el-button type="warning" size="small" @click="editTableClick(scope.row.id)">编辑 </el-button>
                      <el-button type="danger" size="small" @click="deleteTableClick(scope.row.id)"> 删除 </el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <div style="padding-bottom: 8px; display: flex; justify-content: flex-end" v-if="invoiceTableData && invoiceTableData.length > 0">开票合计含税金额：{{ invoiceTableData[0].taxTotalPrice }} 开票合计不含税金额：{{ invoiceTableData[0].totalprice }}</div>
              </div>
            </div>
          </div-border>
          <div class="btnContainer">
            <el-button size="medium" class="searchBtn" @click="auditConfirmClick" :disabled="!(settlementQuantityCalculation === 0 && otherNumCalculation === 0)"> 确定 </el-button>
            <el-button size="medium" class="resetBtn" @click="auditClose">关闭</el-button>
          </div>
        </el-form>
      </div>
    </el-dialog>

    <el-dialog title="修改金额" :visible.sync="modifyAmountPortFlog" width="600px" center :close-on-click-modal="false" @close="modifyRemoveClick">
      <modifyAmountPort ref="modifyAmountPort">
        <!-- 插槽    提交按钮     -->
        <template slot-scope="scope" slot="confirmButton">
          <!--          {{scope.modigyData}}-->
          <el-button class="searchBtn" size="mini" @click="modifyconfirmClick(scope.modigyData)"> 确定 </el-button>
        </template>
        <!-- 插槽    取消按钮     -->
        <template slot="cancelButton">
          <el-button type="info" size="mini" @click="modifyRemoveClick">取消</el-button>
        </template>
      </modifyAmountPort>
    </el-dialog>
    <!-- 创建发票 -->
    <el-dialog title="创建发票" :visible.sync="addInvoiceVisible" width="950px" @close="addInvoiceClose" center :close-on-click-modal="false">
      <div class="depart">
        <add-invoice ref="addInvoice" @addInvoiceClose="addInvoiceClose" />
      </div>
    </el-dialog>

    <!-- 填写发票 -->
    <invoice-information ref="invoiceInformation" @getList="accountList" />
    <!-- 提交开票 -->
    <submit-billing ref="submitBillingRef" @submitBilling="submitBilling" />
  </div>
</template>

<script>
  import { formatDateTime, formatTime, getSessionStore } from '@/config/mUtils';
  import divBorder from '@/components/divBorder.vue';
  import modifyAmountPort from '@/views/settle/client/modifyAmountPort.vue';
  import accountsOtherAdd from '@/views/settle/supplier/components/accountsOtherAdd.vue';
  import portChargesDetail from '@/views/settle/client/components/portChargesDetail.vue';
  import invoice from '@/views/settle/client/components/invoice.vue';
  import addInvoice from '@/views/settle/client/components/addInvoice';
  import invoiceInformation from '@/components/invoiceInformation';
  import { accountList, accountDetail, accountDelete, infoInvoice, deleteInvoice, getInvoiceInfo, getInvoiceList, updateAndDeleteAmount, submitAuditInvoice, cancelApplyFor, delOther, getPageListSOCI, getInfoInvoice, changeTitle, remarkSubmit, hongChong } from '@/service/getData';
  import { getImport } from '@/service/getIP';
  import { baseUrl } from '@/config/env';
  import SubmitBilling from '@/components/submitBilling';
  import { incomeSubmitInvoiceAdd } from '@/service/financial';

  export default {
    components: {
      SubmitBilling,
      divBorder,
      modifyAmountPort,
      accountsOtherAdd,
      portChargesDetail,
      invoice,
      addInvoice,
      invoiceInformation,
    },
    data() {
      return {
        msg: '',
        activeName: 'first',
        activeName1: 'first',
        entrustIpt: '',
        titleIpt: '',
        numIpt: '',
        stateIpt: '',
        timeIpt: ['', ''],
        typeOption: [
          {
            label: '合同价',
            value: '1',
          },
          {
            label: '预结算价',
            value: '2',
          },
          {
            label: '合并价格',
            value: '3',
          },
        ],
        stateOption: [
          {
            value: '',
            label: '全部',
          },
          {
            value: 0,
            label: '待提交审核',
          },
          {
            value: 1,
            label: '审核对账单中',
          },
          {
            value: 2,
            label: '系统开票中',
          },
          {
            value: 3,
            label: '填写快递单号',
          },
          {
            value: 4,
            label: '已收款',
          },
          {
            value: -1,
            label: '审核未通过',
          },
          {
            value: -2,
            label: '系统开票失败',
          },
          {
            value: -10,
            label: '已取消',
          },
        ],
        page: 1,
        size: 10,
        total: 0,
        tableLoad: false,
        tableLoad1: false,
        addLoad: false,
        TableDatas: [
          // {id:111,show:false,entrust:'委托商1',tip:'重庆市xxxx',status:1,tableShow:false,child:[
          //     {id:222,state:1},
          //     {id:333,state:0},
          //   ]},
          // {id:444,show:false,entrust:'委托商1',status:0,tableShow:false,child:[]},
          // {id:555,show:true,entrust:'委托商1',status:2,tableShow:false,child:[]},
          // {id:666,show:true,entrust:'委托商1',status:3,tableShow:false,child:[]},
        ],
        detailDialogVisible: false,
        detailDialogWidth: '1050px',
        detailTable: [],
        detailTable2: [{ price: 12 }],
        detailTable3: [{ price: 12 }],
        detailData: {
          table1: [],
        },
        operationData: [],
        dialogVisible: false,
        dialogTitle: '',
        nameOption: [],
        payOption: [],
        addressOption: [],
        tableData1: [],
        tableData2: [],
        tableData3: [],
        tableData4: [],
        companyData: {},
        carVisible: false,
        selectedCar: [],
        selectCar: [],
        brands: [],
        models: [],
        brands2: [],
        models2: [],
        selectBrand: [],
        selectModel: [],
        allCar: [],
        allModel: [],
        expands: [],
        addVisible: false,
        selectCostTable: [],
        invoiceVisible: false,
        auditVisible: false,
        modifyAmountPortFlog: false, // 修改金额弹窗显示
        auditData: {
          table2: [],
        },
        defaultAuditDataSelectedValue: {},
        auditDataSelectedValue: {
          pushType: -1,
          invoiceLine: 2,
          invoiceBlueOrRed: 0,
          invoiceFlag: 0,
          proxyInvoiceFlag: 0,
          specialTaxRateReason: 0,
        },
        rules2: {
          isSalesList: [
            {
              required: true,
              message: '请选择是否开具销售清单',
              trigger: 'change',
            },
          ],
        },
        numOption: [
          {
            label: 'D31835138135135',
            value: '1',
          },
          {
            label: 'D31835138135135',
            value: '2',
          },
          {
            label: 'D31835138135135',
            value: '3',
          },
          {
            label: 'D31835138135135',
            value: '4',
          },
        ],
        headerCellStyle: {
          color: '#3B3B3B',
          'font-size': '13px',
          height: '48px',
          background: '#E8E8E8',
        },
        cellStyle: {
          color: '#7F7F7F',
          'font-size': '13px',
          height: '52px',
        },
        invoiceTableData: [], // 发票数据
        addInvoiceVisible: false,
        isSalesList: 0, // 是否开具销售清单,
        basicId: 0,
        purchaserId: '', // 委托商 id
        settlementNum: 0, // 未结算数量
        otherNum: 0, // 其他未结算数量
        uploadDis: false, // 批量导入状态
        uploadUrl: '', // 托运费用核对导入
        // 托运费用核对导入
        uploadData: {
          mFile: '', // 托运费用核对导入
        },
        tableData2Loading: false,
        defaultSearchForm: {},
        searchForm: {
          type: 2,
          settNo: '',
          title: '',
          companyName: '',
          reconciliator: '',
          startTime: '',
          endTime: '',
          status: '',
          page: 1,
          rows: 10,
        },
        checkTableData: [], // 列表选中数据
        invoicingLoading: false,
      };
    },
    filters: {
      workTypeFormat(value) {
        switch (value) {
          case 1:
            return '装船';
          case 2:
            return '卸船';
          case 3:
            return '过驳';
        }
      },
      formatTime(val) {
        if (val) {
          return formatTime(val, 'yyyy-mm-dd hh:ii:ss');
        }
        return '';
      },
    },
    computed: {
      getState() {
        return function (state) {
          switch (state) {
            case 0:
              return '待提交审核';
            case 1:
              return '审核对账单中';
            case 2:
              return '系统开票中';
            case 3:
              return '填写快递单号';
            case 4:
              return '已收款';
            case -1:
              return '审核未通过';
            case -2:
              return '系统开票失败';
            case -10:
              return '已取消';
          }
        };
      },
      getTime() {
        return function (time) {
          return formatDateTime(time, 'yyyy年mm月dd日 hh:ii:ss');
        };
      },
      // 合计含税结算金额
      consignorPortInfosSumTaxRate() {
        let sum = 0;
        this.detailData.consignorPortInfos
          ? this.detailData.consignorPortInfos.forEach(item => {
              sum += parseFloat(item.taxPrice);
            })
          : 0;
        return sum;
      },
      /**
       *计算合计
       * @param tableData 表格数据
       * @param field 字段名
       * @returns {function(*, *): number}
       */
      sumCost(tableData, field) {
        return function (tableData, field) {
          let sum = 0;
          tableData
            ? tableData.forEach(item => {
                sum += parseFloat(item[field]);
              })
            : 0;
          return sum;
        };
      },
      settlementPriceCalculation() {
        return this.companyData.settlementPrice ? (this.companyData.settlementPrice - (this.companyData.settlementPrice * this.companyData.taxRate) / 100).toFixed(2) : 0;
      },
      otherFeeCalculation() {
        return this.companyData.otherPrice ? (this.companyData.otherPrice - (this.companyData.otherPrice * this.companyData.taxRate) / 100).toFixed(2) : 0;
      },
      settlementQuantityCalculation() {
        let returnStr = this.auditData.settlementNum;
        this.invoiceTableData.forEach(res => {
          if (res.settlementNum) {
            returnStr -= res.settlementNum;
          }
        });
        this.settlementNum = returnStr;
        return returnStr;
      },
      otherNumCalculation() {
        let returnStr = this.auditData.otherNum;
        this.invoiceTableData.forEach(res => {
          if (res.otherNum) {
            returnStr -= res.otherNum;
          }
        });
        this.otherNum = returnStr;
        return returnStr;
      },
    },
    mounted() {
      this.defaultAuditDataSelectedValue = JSON.parse(JSON.stringify(this.auditDataSelectedValue));
      this.defaultSearchForm = JSON.parse(JSON.stringify(this.searchForm));
      //   this.accountList();
      this.uploadUrl = getImport('/platform/customer/account/checkAccountStatement');
    },
    methods: {
      async hongChong(row) {
        // console.log(row.id);
        this.$confirm('是否生成红冲对账单', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async() => {
          const msg = this.$message({
            // showClose: true,
            iconClass: 'el-icon-loading',
            message: '生成红冲对账单中......'
          });
          const { status, message } = await hongChong({id: row.id});
          if (status !== 0) return this.$message.warning(message);
          msg.close()
          this.$message.success(message);
          this.searchBtn();
        })

      },
      editRemark(row) {
        this.$prompt('备注', '更改备注', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          closeOnClickModal: false,
          inputValue: row.remark
        })
          .then(async ({ value }) => {
            const { status, message } = await remarkSubmit({
              id: row.id,
              remark: value
            });
            if (status !== 0) return this.$message.warning(message);
            this.$message.success(message);
            this.searchBtn();
          })
      },
      //获取发票号
      getInvoiceNo(row) {
        if (row.invoiceManageList !== null) {
          return row.invoiceManageList.map(item => item.invoiceNo).join(',');
        } else {
          return '';
        }
      },
      //获取发票时间
      getInvoiceCreateTime(row) {
        if (row.invoiceManageList !== null) {
          return row.invoiceManageList.map(item => item.createTime).join(',');
        } else {
          return '';
        }
      },
      //获取发票金额
      getInvoicePrice(row) {
        if (row.invoiceManageList !== null) {
          return row.invoiceManageList.map(item => item.taxPrice).join(',');
        } else {
          return '';
        }
      },
      settTypeFormat(r, c, cellValue) {
        switch (cellValue) {
          case 1:
            return '合同价';
          case 2:
            return '预结算价';
          case 3:
            return '合并价格';
        }
      },
      async accountList() {
        this.tableLoad = true;
        const res = await accountList(this.searchForm);
        this.tableLoad = false;
        if (res.status !== 0) return this.$message.error(res.message);
        this.total = res.data.total;
        this.TableDatas = res.data.records;
        this.msg = res.msg;
      },
      async _accountDetail(id) {
        this.$refs.portChargesDetail.loading = true;
        const { status, data, message } = await accountDetail(id);
        this.$refs.portChargesDetail.loading = false;
        if (status !== 0) return this.$message.warning(message);
        if (data.auditRecordList) {
          this.$refs.portChargesDetail.stepData = [];
          // 审核信息数据
          data.auditRecordList.forEach(res => {
            const str = this.strFormat(res.status);
            const state = res.status == 3 ? 'failure' : res.status == 2 ? 'success' : '';
            this.$refs.portChargesDetail.stepData.push({
              title: res.auditorName + str,
              time: res.createTime,
              state,
              remark: res.opinion,
            });
          });
        }
        this.$refs.portChargesDetail.basicId = id;
        this.detailData = data;
        this.detailData.table1 = [
          {
            settNo: data.settNo,
            settLementPrice: data.settlementPrice,
          },
        ];
      },
      compareDate(d1, d2) {
        return new Date(d1.replace(/-/g, '\/')) > new Date(d2.replace(/-/g, '\/'));
      },
      // 结束时间
      dateChange(val) {
        if (this.searchForm.endTime && this.searchForm.startTime && this.compareDate(this.searchForm.startTime, this.searchForm.endTime)) {
          if (val === this.searchForm.endTime) this.searchForm.endTime = '';
          if (val === this.searchForm.startTime) this.searchForm.startTime = '';
          this.$forceUpdate();
          return this.$message.warning('结束日期必须大于开始日期！');
        }
      },
      // 主页面条数
      contractSizeChange(sizes) {
        this.searchForm.rows = sizes;
        this.accountList();
      },
      // 主页面页数
      contractCurrentChange(page) {
        this.searchForm.page = page;
        this.accountList();
      },
      detailClose() {
        this.detailDialogVisible = false;
        this.activeName = 'first';
        this.$refs.portChargesDetail.activeName = 'first';
      },
      dialogClose() {
        this.dialogVisible = false;
        this.tableData1 = [];
        this.tableData2 = [];
        this.activeName = 'first';
        this.accountList();
      },
      // 寄送发票
      addClick(value) {
        console.log(value);
        this.$refs.invoice.$refs.ruleForm.validate(async valid => {
          if (valid) {
            this.addLoad = true;
            this.addLoad = false;

            this.invoiceVisible = false;
          } else {
            return false;
          }
        });
      },
      nameChange() {},
      carClick() {
        this.carVisible = true;
        this.selectCar = [...this.selectedCar];
        this.brands = [...this.brands2];
        this.models = [...this.models2];
      },
      selectRemove(item) {
        this.selectCar.splice(this.selectCar.indexOf(item), 1);
        if (this.brands.indexOf(item) !== -1) {
          this.brands.splice(this.brands.indexOf(item), 1);
        } else {
          this.models.splice(this.models.indexOf(item), 1);
        }
      },
      brandAdd(item) {
        if (this.selectCar.indexOf(item) !== -1) return this.$message.warning('已选择该品牌！');
        let arr = [];
        for (let i = 0; i < this.allCar.length; i++) {
          if (this.allCar[i].id === item.id) {
            arr = this.allCar[i].carModel;
            break;
          }
        }
        for (let i = 0; i < arr.length; i++) {
          for (let j = 0; j < this.selectCar.length; j++) {
            if (arr[i].id === this.selectCar[j].id) {
              this.selectCar.splice(j, 1);
              j--;
            }
          }
        }
        this.selectCar.push(item);
        this.brands.push(item);
      },
      async addClose() {
        this.addVisible = false;
        this.cost = {};
        this.selectCostTable.forEach(item => {
          if (this.tableData2.indexOf(item) === -1) this.tableData2.push(item);
        });
        this.selectCostTable = [];
        this.costTable = [];
      },
      modelAdd(item) {
        for (let i = 0; i < this.selectCar.length; i++) {
          if (this.selectCar[i].id === item.brandId) return this.$message.warning('上方已选择该品牌的全部车型！');
          if (this.selectCar[i].id === item.id) return this.$message.warning('已选择该车型！');
        }
        this.selectCar.push(item);
        this.models.push(item);
      },
      carAddClick() {
        this.carVisible = false;
        this.selectedCar = [...this.selectCar];
        this.brands2 = [...this.brands];
        this.models2 = [...this.models];
      },
      tableRowClassName({ row }) {
        if (row.price1 !== row.price2) return 'ui-warning-row';
        return '';
      },
      // 其他费用添加
      exportClick() {
        this.addVisible = true;
        // 调用子组件 分页查询
        this.$nextTick(() => {
          this.$refs.otherAdds._othercostGetAllByCompanyId();
        });
      },
      removeClick(index, val, type) {
        this.$confirm('确定要删除当前数据吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            if (type) {
              const { status, message } = await delOther({
                accountId: this.basicId,
                otherCostId: val.id,
              });
              if (status !== 0) return this.$message.warning(message);
              this.$message.success(message);
              await this.getPageListSOCI();
            } else {
              const obj = {
                ...val,
                flag: 2,
                operateType: 'delete',
              };
              const res = await updateAndDeleteAmount(obj);
              if (res.status !== 0) return this.$message.error(res.message);
              this.$message.success(res.message);
              this.tableData1.splice(index, 1);
              const { data } = await accountDetail(this.basicId);
              this.companyData = data;
            }
          })
          .catch(() => {});
      },
      addTableClick(index, val) {
        if (val) {
          this.tableData2.push(this.tableData4[index]);
          this.tableData4.splice(index, 1);
        } else {
          this.tableData1.push(this.tableData3[index]);
          this.tableData3.splice(index, 1);
        }
      },
      changePriceClick(index, val) {
        const numReg = new RegExp(/^\d+(\.\d+)?$/);
        this.$prompt('请输入修改金额', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputErrorMessage: '请输入修改金额',
          inputValidator: value => {
            if (!value) return '请输入修改金额';
            if (!numReg.test(value)) return '请输入修改金额（仅非负数字）';
          },
          beforeClose: async (action, instance, done) => {
            if (action === 'cancel') {
              done();
              return;
            }
            val.taxPrice = instance.inputValue;
            let obj = {
              ...val,
              flag: 2,
              operateType: 'update',
            };
            const { status, message } = await updateAndDeleteAmount(obj);
            if (status !== 0) return this.$message.warning(message);
            this.$message.success(message);
            const { data } = await accountDetail(this.basicId);
            this.companyData = data;
            done();
          },
        });
      },

      /** *
       * 子组件添加其他费用触发  得到子组件勾选的数据
       *@param value 子组件传递勾选数据
       * */
      otherData(value) {
        this.tableData2 = value;
      },
      carClose() {
        this.carVisible = false;
      },
      brandClick(id) {
        for (let i = 0; i < this.allCar.length; i++) {
          if (this.allCar[i].id === id) {
            this.selectModel = this.allCar[i].carModel.map(item => ({
              id: item.id,
              name: item.brand_name,
              brandId: item.brand_id,
            }));
            break;
          }
        }
      },
      deleteClick(id, reconciliator) {
        this.$confirm('确认删除当前对账单吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const { status, message } = await accountDelete(id, reconciliator);
            if (status === 0) {
              this.$message.success(message);
              this.searchBtn();
            } else {
              this.$message.warning(message);
            }
          })
          .catch(() => {});
      },
      hiddenClick(index, row) {
        this.TableDatas[index].tableShow = !this.TableDatas[index].tableShow;
        Array.prototype.remove = function (val) {
          const index = this.indexOf(val);
          if (index > -1) {
            this.splice(index, 1);
          }
        };
        if (this.expands.indexOf(row.id) < 0) {
          this.expands.push(row.id);
        } else {
          this.expands.remove(row.id);
        }
      },
      disableClick(id, reconciliator) {
        this.$confirm('确认要取消审核申请吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const { status, message } = await cancelApplyFor(id, reconciliator);
            if (status !== 0) return this.$message.warning(message);
            this.$message.success(message);
            await this.accountList();
          })
          .catch(() => {});
      },
      detailClick(id, settNo) {
        this.detailDialogVisible = true;
        this.$nextTick(() => {
          this._accountDetail(id);
          this.getInfoInvoice(id, settNo);
        });
      },
      async getInfoInvoice(id, settNo) {
        const { status, data, message } = await getInfoInvoice(id);
        if (status !== 0) return this.$message.warning(message);
        this.$refs.portChargesDetail.infoInvoice = data;
        this.$refs.portChargesDetail.actNo = settNo;
      },
      invoiceClose() {
        this.invoiceVisible = false;
        this.$refs.invoice.$refs.ruleForm.resetFields();
      },
      invoiceClick() {
        this.invoiceVisible = true;
        this.invoiceData = {
          type: 1,
        };
      },
      async titleChange(id, reconciliator) {
        this.$prompt('标题', '更改标题', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          closeOnClickModal: false,
        })
          .then(async ({ value }) => {
            const { status, message } = await changeTitle({
              id,
              title: value,
              reconciliator,
            });
            if (status !== 0) return this.$message.warning(message);
            this.$message.success(message);
            await this.accountList();
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '取消修改',
            });
          });
      },
      /**
       * 核对对账单
       * @param id 表格id
       * @returns {Promise<ElMessageComponent>}
       */
      async changeClick(id) {
        const { status, data, message } = await accountDetail(id);
        // companyData
        if (status !== 0) return this.$message.error(message);
        this.basicId = id;
        this.dialogTitle = '核对对账单';
        this.dialogVisible = true;
        this.companyData = data;
        await this.getPageListSOCI();
      },
      // 查询
      searchBtn() {
        this.page = 1;
        this.accountList();
      },
      resetBtn() {
        this.searchForm = JSON.parse(JSON.stringify(this.defaultSearchForm));
      },
      async auditClick(id, reconciliator) {
        this.auditDataSelectedValue = JSON.parse(JSON.stringify(this.defaultAuditDataSelectedValue));
        const { status, data, message } = await getInvoiceInfo(id);
        if (status !== 0) return this.$message.error(message);
        this.auditData = data;
        this.basicId = id;
        this.reconciliator = reconciliator;
        this.purchaserId = data.purchaserId;
        this.auditVisible = true;
        this.$nextTick(() => {
          this.getInvoiceList(id);
        });
      },
      auditClose() {
        this.auditVisible = false;
        this.$refs.ruleForm2.resetFields();
      },
      auditConfirmClick() {
        this.auditData.isSalesList = this.isSalesList;
        this.$refs.ruleForm2.validate(async valid => {
          if (valid) {
            const { status, message } = await submitAuditInvoice({
              id: this.basicId,
              isDetailedList: this.isSalesList,
              type: 2,
              ...this.auditDataSelectedValue,
              reconciliator: this.reconciliator,
            });
            if (status === 0) {
              this.$message.success(message);
              this.auditVisible = false;
              await this.accountList();
            } else {
              this.$message.warning(message);
            }
          } else {
            return false;
          }
        });
      },
      numChange(index) {
        this.auditData.table[index].max = 123;
        this.auditData.table[index].price = 456;
      },
      addCl() {
        this.auditData.table.push({ num: '' });
      },
      addCl2() {
        this.auditData.table2.push({ price: '' });
      },
      numRemoveClick(index) {
        this.auditData.table.splice(index, 1);
      },
      invoiceRemoveClick(index) {
        this.auditData.table2.splice(index, 1);
      },
      /**
       * 修改金额，确定
       * @param value 子组件插槽传递的数据
       */
      modifyconfirmClick(value) {
        this.$refs.modifyAmountPort.$refs.ruleForm.validate(valid => {
          if (valid) {
          } else {
          }
        });
      },
      // 修改金额，窗口关闭 ，清除数据
      modifyRemoveClick() {
        this.$refs.modifyAmountPort.$refs.ruleForm.resetFields();
        for (const modigyDataKey in this.$refs.modifyAmountPort.modigyData) {
          this.$refs.modifyAmountPort.modigyData[modigyDataKey] = '';
        }
        this.modifyAmountPortFlog = false;
      },
      //模板下载
      download() {
        window.location.href = '/file/委托商港口费核对.xlsx';
      },
      beforeUpload(file) {
        this.tableLoad1 = true;
        this.uploadDis = true;
        if (file.name.split('.')[file.name.split('.').length - 1] == 'xls' || file.name.split('.')[file.name.split('.').length - 1] == 'xlsx') {
          this.uploadData.mFile = file.name;
        } else {
          this.uploadDis = false;
          this.tableLoad1 = false;
          this.$message.error('请选择excel文件导入！！！');
          return false;
        }
      },
      uploadHttp(content) {
        let formData = new FormData();
        formData.append('file', content.file, content.file.name);
        console.log(content);
        console.log(formData);
        let that = this;
        this.$axios({
          method: 'post',
          url: content.action + '&id=' + that.basicId,
          timeout: 600 * 1000,
          data: formData,
          headers: { 'content-type': 'multipart/form-data' },
        })
          .then(res => {
            this.uploadDis = false;
            this.tableLoad1 = false;
            this.$alert(res.data.message, '提示', {
              confirmButtonText: '关闭',
              callback: async () => {
                this.tableData1 = res.data.data;
              },
            });
            // that._transportPlanCvPageList()
          })
          .catch(error => {
            if (error.response) {
              that.$message.error('配时文件上传失败(' + error.response.status + ')，' + error.response.data);
              console.log('配时文件上传失败(' + error.response.status + ')，' + error.response.data);
            } else if (error.request) {
              that.$message.error('配时文件上传失败，服务器端无响应');
              console.log('配时文件上传失败，服务器端无响应');
            } else {
              that.$message.error('配时文件上传失败，请求封装失败');
              console.log('配时文件上传失败，请求封装失败');
            }
            this.uploadDis = false;
            this.tableLoad1 = false;
          });
      },
      /**
       * 核对对账单 导入 成功函数
       * @param res 上传成功回调
       */
      planOnSuccess(res) {
        this.uploadDis = false;
        this.tableLoad1 = false;
        if (res.status !== 0) return this.$message.error(res.message);
        this.$message.success(res.message);
        // this._transportPlanCvPageList()
        // this.TableDatas = res.data;
        this.$forceUpdate();
      },
      async editTableClick(id) {
        const { data, status, message } = await infoInvoice(id);
        if (status !== 0) return this.$message.warning(message);
        this.addInvoiceVisible = true;
        this.$nextTick(() => {
          this.$refs.addInvoice.invoiceData = data;
          this.$refs.addInvoice.settlementNum = this.settlementNum + data.settlementNum;
          this.$refs.addInvoice.otherNum = this.otherNum;
          this.$refs.addInvoice.addOrEdit = 'edit';
          this.$refs.addInvoice.getServiceName();
          this.$refs.addInvoice.getSelection(this.purchaserId);
        });
      },
      deleteTableClick(id) {
        this.$confirm('确认删除当前发票吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const res = await deleteInvoice(id);
            if (res.status === 0) {
              this.$message.success(res.message);
              await this.getInvoiceList(this.basicId);
            } else {
              this.$message.error(res.message);
            }
          })
          .catch(() => {});
        this.invoiceTableData.splice(index, 1);
      },
      // 关闭新增发票弹出框
      addInvoiceClose(type) {
        if (type === 'confirm') {
          this.getInvoiceList(this.basicId);
        }
        this.addInvoiceVisible = false;
        // this.$refs.ruleForm.resetFields();
      },
      // 打开新增发票弹出框
      addInvoice() {
        this.addInvoiceVisible = true;
        this.$nextTick(() => {
          this.$refs.addInvoice.invoiceData.basicId = this.basicId;
          this.$refs.addInvoice.settlementNum = this.settlementNum;
          this.$refs.addInvoice.otherNum = this.otherNum;
          this.$refs.addInvoice.addOrEdit = 'add';
          this.$refs.addInvoice.getServiceName();
          this.$refs.addInvoice.getSelection(this.purchaserId);
          // this.$refs.addInvoice.settlementNum = this.settlementQuantityCalculation()
        });
      },
      // 获取发票数据
      async getInvoiceList(id) {
        const { data, status, message } = await getInvoiceList(id);
        if (status === 0) {
          this.invoiceTableData = data;
        } else {
          this.$message.warning(message);
        }
      },
      // 格式化审核信息状态
      strFormat(val) {
        let returnStr = '';
        switch (val) {
          case 0:
            returnStr = ' 重新发起';
            break;
          case 1:
            returnStr = ' 发起';
            break;
          case 2:
            returnStr = ' 同意';
            break;
          case 3:
            returnStr = ' 拒绝';
            break;
          case 4:
            returnStr = ' 取消审核';
            break;
          default:
            returnStr = '';
            break;
        }
        return returnStr;
      },
      async getPageListSOCI() {
        this.addVisible = false;
        this.tableData2Loading = true;
        const { status, message, data } = await getPageListSOCI({
          id: this.basicId,
          page: 1,
          rows: 10,
        });
        this.tableData2Loading = false;
        if (status !== 0) return this.$message.warning(message);
        this.tableData2 = data ? data.records : [];
      },
      fillInInvoice(id) {
        this.$refs.invoiceInformation.openDialog(id);
      },
      async exportDatas() {
        window.exportExcelAllFunc({
          type: 'get',
          url: '/customer/account/export',
          obj: {
            ...this.searchForm,
            id: this.checkTableData.map(item => item.id).join(',')
          }
        });
      },
      // 导出数据
      exportData() {
        let token = getSessionStore('token');
        const ids = [];
        this.checkTableData.forEach(item => {
          ids.push(item.id);
        });
        const exportParams = {
          ...this.searchForm,
          ids: ids,
        };
        window.exportExcel(baseUrl + `/platform/customer/accountPrice/export?access_token=${token}`, exportParams, '委托商港口费用对账单结算数据');
        this.clearCheckTableData();
      },
      selectionDataChange(selection) {
        this.checkTableData = selection;
      },
      rowStyle({ row }) {
        return this.checkTableData.includes(row) ? { background: 'rgb(197 226 255)' } : {};
      },
      clearCheckTableData() {
        this.$refs.listTable.clearSelection();
        this.checkTableData = [];
        this.accountList();
      },
      async submitBillingClick(id) {
        // this.invoicingLoading = true;
        // const {
        //   status,
        //   message,
        //   data,
        // } = await incomeSubmitInvoiceDetail({ id });
        // this.invoicingLoading = false;
        // if (status !== 0) return this.$message.warning(message);
        this.$refs.submitBillingRef.invoicingOpen({ id: 1 });
      },
      async submitBilling(invoiceManageList) {
        const { status, message } = await incomeSubmitInvoiceAdd({ invoiceManageList });
        this.$refs.submitBillingRef.invoicingLoading = false;
        if (status !== 0) return this.$message.warning(message);
        this.$refs.submitBillingRef.invoicingClose();
        this.$message.success(message);
      },
    },
  };
</script>

<style lang="scss" scoped>
  .mainContainer {
    width: 100%;
    padding: 20px 15px 0 25px;
    //margin-top: 30px;
    //background-color: rgb(244, 247, 251);

    .line {
      width: 12px;
      height: 32px;
      background-color: rgba(51, 84, 131, 100);
      margin-right: 10px;
    }

    .line + span {
      font-size: 16px;
      color: rgba(51, 84, 131, 100);
      font-weight: 600;
    }

    .nav {
      width: 100%;
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      .navContainer p {
        display: inline-block;
        width: 90px;
        text-align: right;
      }

      &Container {
        width: 200px;
        display: flex;
        align-items: center;
        margin-right: 5px;
        margin-bottom: 5px;

        p {
          font-size: 14px;
          color: rgba(16, 16, 16, 100);
        }
      }

      &Btn {
        display: flex;
        align-items: center;
        margin-bottom: 5px;
      }

      ::v-deep {
        label.el-form-item__label {
          font-weight: 500;
          color: #101010;
        }
      }
    }

    .content {
      display: flex;
      flex-direction: column;
      align-items: center;

      .tableContainer {
        margin-top: 30px;
        margin-bottom: 25px;
        width: 100%;

        ::v-deep {
          .el-table__expand-icon:after {
            content: '';
          }

          .el-table__expand-icon > i {
            display: none;
          }

          .el-table__expand-column {
            border-right: none;
          }

          body .el-table th.gutter {
            display: table-cell !important;
          }

          .el-badge__content {
            top: 4px !important;
            right: 1px !important;
          }

          .el-badge__content {
            background-color: #f56c6c !important;
          }

          .el-table .cell {
            padding: 0;
          }

          .el-table th {
            padding: 0;
          }

          .el-table td {
            padding: 0;
          }
        }
      }

      .paginationContainer {
        margin-right: auto;
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        span {
          font-size: 13px;
        }
      }
    }

    .carContainer {
      width: 100%;
      padding: 15px 40px 10px 20px;
      max-height: 75vh;
      overflow: auto;

      &Title {
        display: flex;
        flex-direction: column;

        span {
          color: #101010;
          font-weight: 700;
          margin-bottom: 5px;
        }

        &Content {
          width: 100%;
          padding-left: 15px;
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          margin-bottom: 10px;

          &Item {
            height: 25px;
            padding: 0 5px;
            background-color: #a4adb3;
            color: #fff;
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-right: 10px;
            margin-bottom: 5px;

            i {
              color: #000;
              font-size: 17px;
              cursor: pointer;
            }

            p {
              cursor: pointer;
            }
          }
        }
      }

      .btnContainer {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 30px 0 10px 0;

        button {
          margin: 0 15px;
        }
      }
    }

    .detail {
      width: 100%;
      padding: 10px 0 20px 20px;
      max-height: 80vh;
      overflow: auto;

      ::v-deep {
        .el-table td,
        .el-table th {
          padding: 0;
        }

        .cell {
          font-size: 10px;
          padding: 0;
        }
      }

      .baseInfo {
        display: flex;
        flex-direction: column;

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;

          &Item {
            margin-bottom: 20px;

            .imgContainer {
              display: flex;
              align-items: center;
            }

            .span1 {
              font-weight: 700;
            }

            span {
              font-size: 14px;
            }

            .specialOne {
              width: 50%;
            }
          }

          .specialItem {
            display: flex;
          }
        }
      }

      .operation {
        display: flex;
        flex-direction: column;

        ::v-deep {
          .el-table .ui-warning-row {
            background-color: #fef0f0 !important;
          }

          .el-table--enable-row-hover .el-table__body tr.ui-warning-row:hover > td {
            background-color: #fef0f0 !important;
          }

          .el-table .ui-warning-row .cell {
            color: red;
          }
        }

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Table {
          width: 100%;
          margin-top: 10px;
          padding: 0 20px;

          &Nav {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: flex-end;

            span {
              color: rgba(51, 136, 255, 1);
              text-decoration: underline;
              margin-right: 10px;

              &:hover {
                cursor: pointer;
              }
            }
          }
        }
      }
    }

    .reasonContainer {
      width: 100%;
      padding: 20px 30px;

      ::v-deep {
        .el-textarea__inner {
          min-height: 100px !important;
        }
      }

      .reasonBtn {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-end;
      }
    }

    .addCost {
      display: flex;
      flex-direction: column;
      padding: 10px 40px 10px 10px;
      max-height: 75vh;
      overflow: auto;

      &Nav {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
      }

      &Table {
        margin-top: 30px;
        margin-bottom: 25px;
        width: 100%;

        ::v-deep {
          .el-table__expand-icon:after {
            content: '';
          }

          .el-table__expand-icon > i {
            display: none;
          }

          .el-table__expand-column {
            border-right: none;
          }

          body .el-table th.gutter {
            display: table-cell !important;
          }

          .el-table__header .el-table-column--selection .cell .el-checkbox:after {
            color: rgb(127, 127, 127);
            content: '全选';
            font-size: 12px;
            font-weight: 700;
            //margin-left: 2px;
          }

          .el-table__header .el-table-column--selection .cell .el-checkbox {
            margin-left: 8px;
          }

          .el-checkbox {
            margin-left: 16px;
          }

          .el-table .cell {
            padding: 0;
          }

          .el-table th {
            padding: 0;
          }

          .el-table td {
            padding: 0;
          }
        }
      }

      .paginationContainer {
        margin-right: auto;
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        span {
          font-size: 13px;
        }
      }
    }

    .depart {
      width: 100%;
      padding: 10px 40px 10px 10px;
      max-height: 75vh;
      overflow: auto;

      &Table {
        margin-bottom: 25px;
        width: 100%;

        .tableAddBtnContainer {
          border: 1px solid #ebeef5;
          border-top-style: none;
          width: 100%;
          height: 35px;
          display: flex;
          align-items: center;
          padding-left: 15px;

          .AddContainer {
            display: flex;
            align-items: center;

            &:hover {
              cursor: pointer;
            }
          }

          img {
            object-fit: cover;
            margin-right: 5px;
          }

          p {
            font-size: 13px;
            color: #f59a23;
            font-family: 'Arial Normal', 'Arial', sans-serif;
          }
        }

        ::v-deep {
          .el-table .cell {
            padding: 0;
          }

          .el-table th {
            padding: 0;
          }

          .el-table td {
            padding: 0;
          }
        }
      }

      .specialItem {
        ::v-deep {
          .el-form-item__content {
            margin-left: 0 !important;
          }
        }
      }

      ::v-deep {
        .el-form-item__label {
          font-weight: 700;
        }

        .el-form-item {
          margin-bottom: 13px;
        }

        .el-form-item__label {
          padding: 0;
        }

        .el-form-item__content {
          position: relative;
        }
      }

      .btnContainer {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 30px 0 10px 0;

        button {
          margin: 0 15px;
        }
      }
    }

    ::v-deep {
      .el-table th > .cell {
        font-weight: 700 !important;
      }
    }
  }

  ::v-deep {
    .el-dialog__header {
      padding: 9px 20px 9px;
      background: #335483;
    }

    .el-dialog__title {
      line-height: 24px;
      font-size: 14px;
      color: #ffffff;
    }

    .el-dialog__headerbtn {
      top: 9px;
    }

    .el-dialog__headerbtn .el-dialog__close {
      color: #fff;
      font-size: 25px;
    }

    .el-dialog__body {
      padding: 0;
    }
  }

  .spanStyle {
    color: rgb(51, 136, 255);
    cursor: pointer;
    margin-left: 10px;
  }
  .mainContainer[data-v-2b2de187] {
    background-color: rgb(244, 247, 251);
  }

  .btnTopBottom10 {
    margin-top: 10px;
    margin-bottom: 10px;
  }
</style>
